<div [ngClass]="{ 'global-loader-wrapper': !isLocal }">
  <p-progressSpinner class="loader"></p-progressSpinner>
</div>
